import { JobseekersModule } from './jobseekers/jobseekers.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { AuthGuard } from './core/auth.guard';
import { RouteApplicationStartupResolveService } from './core/route-application-startup-resolve.service';

const appRoutes: Routes = [
  { path: '', redirectTo: '/customers', pathMatch: 'full' },
  { path: 'signin', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule), 
    resolve: { appData: RouteApplicationStartupResolveService } },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(appRoutes, {})],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
